import { PropertySelector } from "../PropertySelector";
import { ShapefileBundleWizardProps, WizardStep } from "../Wizard";
import { TemplateExample } from "../TemplateExample";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FarmIcon from "portal/images/icons/farm.svg?react";
import React from "react";

export const BuildFarmName: WizardStep<ShapefileBundleWizardProps> = {
  stepNameI18NKey: "views.farms.importFarms.step2BuildFarmName.stepName",
  Render: ({
    inputFeatures,
    propertyExamples,
    farmNameTemplate,
    setFarmNameTemplate,
  }) => {
    const { t } = useTranslation();
    const firstFeature = inputFeatures[0];

    return (
      <>
        <div>
          {t("views.farms.importFarms.step2BuildFarmName.instructions")}
        </div>
        <Typography variant="h6">
          {t("views.farms.importFarms.step2BuildFarmName.exampleFarmName")}
        </Typography>
        <div>
          {firstFeature && farmNameTemplate.length > 0 ? (
            <TemplateExample
              template={farmNameTemplate}
              properties={firstFeature.properties}
            />
          ) : (
            <span>
              {t("views.farms.importFarms.step2BuildFarmName.noneSelected")}
            </span>
          )}
        </div>
        <PropertySelector
          Icon={FarmIcon}
          iconTooltip="Farm Name"
          propertyExamples={propertyExamples}
          selectedPropertyList={farmNameTemplate}
          updateSelectedPropertyList={setFarmNameTemplate}
        />
      </>
    );
  },
  mapSelectionEnabled: false,
  canAdvancePastStep: ({ farmNameTemplate }) => farmNameTemplate.length > 0,
};
